module.exports = __webpack_public_path__ + "static/media/profile-icon.5d43d38e.jpg";